module.exports = __webpack_public_path__ + "front/img/tab-bg-active.f02e109f.png";